import { motion } from 'framer-motion';

export default function BrandStory() {
  return (
    <section id="story" className="relative bg-[#FAF8F4] py-32 lg:py-48">
      <div className="max-w-3xl mx-auto px-6 lg:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.9 }}
          className="text-[11px] tracking-[0.35em] uppercase text-[#CBBBA0] mb-10"
        >
          Chapter 07 · Why We Exist
        </motion.div>

        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.1, delay: 0.15 }}
          className="font-display text-[clamp(2.25rem,5.5vw,4.5rem)] leading-[1.02] tracking-[-0.03em] text-[#111]"
        >
          Modern life moves <span className="font-serif italic">fast.</span>
        </motion.h2>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.4 }}
          className="mt-10 text-[18px] md:text-[20px] leading-[1.7] text-[#111]/70"
        >
          KIVO exists to help people reconnect with better daily habits through
          products designed with intention — quietly, beautifully, and on
          purpose.
        </motion.p>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1, delay: 0.7 }}
          className="mt-14 inline-flex items-center gap-3 text-[11px] tracking-[0.3em] uppercase text-[#111]/40"
        >
          <span className="h-px w-10 bg-[#111]/20" />
          Original by Choice.
          <span className="h-px w-10 bg-[#111]/20" />
        </motion.div>
      </div>
    </section>
  );
}
